import React from "react";

import BoiReactMarkdown from "../../boi-markdown/boi-markdown";
import { PageActionsContainer, PageContainer } from "../../theme/containers";
import { SecondaryButton } from "../../simple-buttons/simple-buttons";
import { SVGWarningIcon } from "../../svg-animated/svg-animated";
import { replaceMergeTagsInString } from "../../forms/helper";
import { BIFAuthScreenProps } from "../types";

const FailedVerification = ({
    context,
    failedVerification,
    setScreen
}: BIFAuthScreenProps) => (
    <PageContainer
        pl={0}
        pr={0}
        pt={0}
        alignItems={"stretch"}
        textAlign="center">
        <SVGWarningIcon className="u-mx-auto" />
        <BoiReactMarkdown className={"u-mb-3 u-mt-4"}>
            {(failedVerification &&
                replaceMergeTagsInString(
                    failedVerification,
                    context ? context.getValues() : {}
                )) ||
                "# Failure." +
                    "\nThe verification has failed.\n"
            }
        </BoiReactMarkdown>
        <PageActionsContainer className="block">
            <SecondaryButton
                onClick={() => setScreen("verification")}
                text="Back" />
        </PageActionsContainer>
    </PageContainer>
);

export default FailedVerification;
